import { AppType } from "./constants/AppType";

export function getAppType() {
  if (window.cvpEmbedType) {
    return AppType.iframe;
  }

  return AppType.cvWebtempNo;
}

export function isAppTypeIframe() {
  return getAppType() === AppType.iframe;
}
